var _rect, _path, _rect2, _circle, _line, _rect3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeeds(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28.1951,
    height: 27,
    transform: "translate(2.66699 10.4574) rotate(-5)",
    fill: "#8C8F9A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.869 21.1557C24.8383 20.8053 24.6698 20.4815 24.4003 20.2554C24.1309 20.0293 23.7827 19.9195 23.4323 19.9502L19.2577 20.3154L19.6277 17.2413C19.6351 17.174 19.6354 17.1008 19.629 17.0281C19.6053 16.7573 19.4711 16.5161 19.2771 16.3534L18.5163 15.7211L14.5501 20.4477C14.3271 20.7135 14.2107 21.0565 14.2425 21.4198L14.8204 28.0253C14.851 28.3756 15.0196 28.6995 15.2891 28.9256C15.5585 29.1516 15.9067 29.2614 16.2571 29.2308L22.202 28.7106C22.7502 28.6627 23.1903 28.2914 23.3469 27.7985L24.9343 22.9671C24.9804 22.81 24.9996 22.6485 24.9846 22.4768L24.869 21.1557ZM10.9727 29.6931L13.6149 29.4619L12.9214 21.5354L10.2792 21.7665L10.9727 29.6931Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24.0895,
    y: 15.6761,
    width: 30.1951,
    height: 30,
    transform: "rotate(6 24.0895 15.6761)",
    fill: "#0096CC"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36.1335,
    cy: 31.0152,
    r: 6.125,
    transform: "rotate(-39 36.1335 31.0152)",
    stroke: "white",
    strokeWidth: 1.75
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 40.3895,
    y1: 36.4399,
    x2: 44.2441,
    y2: 41.1999,
    stroke: "white",
    strokeWidth: 1.75
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 24.0895,
    y: 15.6761,
    width: 30.1951,
    height: 30,
    transform: "rotate(6 24.0895 15.6761)",
    stroke: "white",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeeds);
export default __webpack_public_path__ + "static/media/feeds.7768bf0ec9a7fd87a2b762df8550d515.svg";
export { ForwardRef as ReactComponent };